module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('menu', {
    staticClass: "menu",
    class: _vm.classes,
    style: (("height:" + _vm.height + "px;"))
  }, [_c('li', {
    staticClass: "menu__tray menu__tray--nodes"
  }, [_c('nav', {
    staticClass: "menu__nav"
  }, [_c('router-link', {
    staticClass: "menu__link",
    attrs: {
      "to": "/",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('menu-close')
      }
    }
  }, [_vm._v(_vm._s(_vm.homeNode.meta.label))]), _vm._v(" "), _vm._l((_vm.nodes), function(node) {
    return (!node.meta.hidden && node.meta.index) ? _c('router-link', {
      staticClass: "menu__link",
      attrs: {
        "to": node.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('menu-close')
        }
      }
    }, [_vm._v(_vm._s(node.meta.label))]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('li', {
    staticClass: "menu__tray menu__tray--links"
  }, [_c('nav', {
    staticClass: "menu__nav"
  }, [_vm._l((_vm.links), function(link) {
    return _c('router-link', {
      staticClass: "menu__link",
      attrs: {
        "to": link.path
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('menu-close')
        }
      }
    }, [_vm._v(_vm._s(link.label))])
  }), _vm._v(" "), _c('router-link', {
    staticClass: "menu__link menu__link--cta",
    attrs: {
      "to": "/infolettre"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('menu-close')
      }
    }
  }, [_c('icon', {
    attrs: {
      "id": "newsletter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Infolettre")])], 1)], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bbeb60d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/MobileMenu.vue
// module id = 645
// module chunks = 1